import React from 'react';

interface SearchButtonProps {
  text: string;
  testId?: string;
  className?: string;
  onClick?: () => void;
}

const SearchButton: React.FC<SearchButtonProps> = ({
  text,
  testId,
  className,
  onClick,
}) => {
  return (
    <div
      data-testid={testId}
      onClick={onClick}
      className={`noto-13-medium flex items-center justify-center text-black text-opacity-60 shadow-4 filter hover:bg-[#FCC53C] ${className} h-[36px] w-[100px] rounded-[5px] bg-[#FFD365]`}
    >
      {text}
    </div>
  );
};

export default SearchButton;
